import { getCssVar } from '@/utils/getCssVar'

const getCssVarsForAntDesignToken = (isAccessibilityEnhanced = false) => {
	const baseFontSize = +(getCssVar('base-font-size')?.replace('px', '') ?? 16)
	const baseBorderRadius = +(getCssVar('base-border-radius')?.replace('px', '') ?? 4)
	const getFormCssVar = (name) =>
		getCssVar(isAccessibilityEnhanced ? `${name}-accessibility` : name)

	return {
		primaryColor: getCssVar('primary-color'),
		secondaryColor: getCssVar('secondary-color'),
		infoColor: getCssVar('info-color'),
		successColor: getCssVar('success-color'),
		warnColor: getCssVar('warning-color'),
		formBorderColor: getFormCssVar('form-border-color'),
		formTextColor: getFormCssVar('form-text-color'),
		formErrorBgColor: getFormCssVar('form-error-bg-color'),
		errorColor: getFormCssVar('error-color'),
		textColor: getCssVar('main-text-color'),
		blueColor: getCssVar('blue-color'),
		bodyBgColor: getCssVar('body-bg-color'),
		mainFontFamily: getCssVar('main-font'),
		baseFontSize,
		baseBorderRadius,
	}
}

export const getAntDThemeToken = (isAccessibilityEnhanced = false) => {
	const cssVars = getCssVarsForAntDesignToken(isAccessibilityEnhanced)

	return {
		borderRadius: cssVars.baseBorderRadius,
		borderRadiusLG: cssVars.baseBorderRadius * 2,
		colorBgBase: '#fff',
		colorBorder: cssVars.formBorderColor,
		colorError: cssVars.errorColor,
		colorErrorOutline: `transparent`,
		colorErrorBg: cssVars.formErrorBgColor,
		colorInfo: cssVars.infoColor,
		colorPrimary: cssVars.primaryColor,
		colorSuccess: cssVars.successColor,
		colorTextBase: cssVars.textColor,
		colorTextPlaceholder: cssVars.formTextColor,
		colorWarning: cssVars.warnColor,
		colorLink: cssVars.blueColor,
		fontFamily: cssVars.mainFontFamily,
		fontSize: cssVars.baseFontSize,
		/* This token applies specifically to the background of buttons with type="primary" on hover. */
		colorPrimaryHover: getCssVar('light-gray-color'),
		/* This token applies specifically to the text color of buttons with type="primary" on hover. */
		colorTextLightSolid: getCssVar('main-text-color'),
		controlItemBgActive: `${cssVars.secondaryColor}40`,
		controlHeightLG: 48,
		lineWidth: 2,
		InputNumber: {
			paddingInlineLG: 20,
		},
	}
}
